var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIconXl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.522177 28.9347C-0.163933 29.6209 -0.184112 30.7915 0.522177 31.4777C1.22847 32.164 2.39889 32.164 3.085 31.4777L16 18.5607L28.915 31.4777C29.6011 32.164 30.7917 32.1841 31.4778 31.4777C32.1639 30.7713 32.1639 29.6209 31.4778 28.9347L18.5628 15.9975L31.4778 3.08044C32.1639 2.39422 32.1841 1.22361 31.4778 0.537396C30.7715 -0.169005 29.6011 -0.169005 28.915 0.537396L16 13.4544L3.085 0.537396C2.39889 -0.169005 1.20829 -0.189188 0.522177 0.537396C-0.163933 1.2438 -0.163933 2.39422 0.522177 3.08044L13.4372 15.9975L0.522177 28.9347Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconXl);
export default __webpack_public_path__ + "static/media/close-icon-XL.cea6950657ddea2127abf8f4d78dd4a1.svg";
export { ForwardRef as ReactComponent };